<template>
    <div>
        <v-btn
            rounded
            elevation="0"
            dark
            size="small"
            @click="cityInseeCodeDialog = true"
            class="mx-1"
        >
            <v-icon size="small">$oss-help</v-icon>
            <span class="pl-2">Code INSEE</span>
        </v-btn>
        <oss-dialog
            v-if="cityInseeCodeDialog"
            v-model="cityInseeCodeDialog"
            title="Table de correspondance - Code INSEE"
            @close="cityInseeCodeDialog = false"
        >
            <div style="width: 750px">
                <v-row no-gutters class="d-flex justify-center">
                    <v-col cols="6" class="d-flex justify-center align-center mt-5">
                        <v-text-field-filled
                            v-model="cityInput"
                            label="Ville ou code postal"
                            outlined
                            dense
                            class="mr-5"
                        />
                        <v-btn rounded dark elevation="0" size="small" @click="getCityInseeCode()">
                            Rechercher
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-container>
                        <v-data-table
                            :headers="citiesHeaders"
                            :items="cities"
                            :hover="true"
                            hide-default-footer
                        />
                    </v-container>
                </v-row>
            </div>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import axios from "axios";
import { Component, toNative, Vue } from "vue-facing-decorator";

@Component({})
export class DeclarationManagerInsee extends Vue {
    cityInseeCodeDialog: boolean = false;

    cityInput: string = "";

    cities = [];

    citiesHeaders = [
        { title: "Département", value: "department" },
        { title: "Ville", value: "city" },
        { title: "Code postal", value: "postal" },
        { title: "Code INSEE", value: "insee" },
    ];

    async getCityInseeCode() {
        await axios
            .get(
                `https://data.opendatasoft.com//api/records/1.0/search/?dataset=correspondance-code-insee-code-postal%40public&q=${this.cityInput}`,
            )
            .then((response) => {
                if (response.data?.records) {
                    this.cities = response.data.records.map((record) => {
                        return {
                            department: record.fields?.nom_dept,
                            city: record.fields?.nom_comm,
                            postal: record.fields?.postal_code,
                            insee: record.fields?.insee_com,
                        };
                    });
                }
            });
    }
}

export default toNative(DeclarationManagerInsee);
</script>
